<ngx-ui-loader [fgsTemplate]="foregroundSpinner"></ngx-ui-loader>

<ng-template #foregroundSpinner>
	<div class="sk-chase">
		<img class="sk-chase-dot" src="/assets/images/logo-loading.svg">
		<p class="loader-text">Bezig met laden...</p>
	</div>
</ng-template>

<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>